import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';
import Select from 'react-select';

import { ATTRIBUTE_VALUES } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';

function ProductListChangeStatusModal({ show, onHide, statusUpdate, productListId }) {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const { data: { attribute_values } = {} } = useGet(ATTRIBUTE_VALUES, { global_attribute_id: 60 });

  const attributeValuesForDropdown = attribute_values?.map(attribute_value => ({
    label: attribute_value.attribute_value,
    value: attribute_value.attribute_value,
  }));
  return (
    <Modal animation={false} centered show={show} onHide={onHide}>
      <Modal.Header className="border-0" closeButton>
        <Modal.Title>Select the status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Status</Form.Label>
          <Select
            options={attributeValuesForDropdown}
            value={attributeValuesForDropdown?.find(option => option.value === selectedStatus)}
            onChange={option => setSelectedStatus(option.value)}
          />
        </Form.Group>
        <Button
          variant="primary"
          onClick={() => {
            statusUpdate({ product_list_id: productListId, status: selectedStatus });
            onHide();
          }}
        >
          Change Status
        </Button>
      </Modal.Body>
    </Modal>
  );
}

ProductListChangeStatusModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  statusUpdate: PropTypes.func,
  productListId: PropTypes.string,
};

export default ProductListChangeStatusModal;
